export default "__VITE_ASSET__DKSvN_Fy__"